import React from 'react'
import Confetti from 'react-confetti'

type Props = {
  open: boolean
}

const THConfetti: React.FC<Props> = ({ open }) => (
  <>
    <Confetti
      className='th-confetti'
      numberOfPieces={500}
      recycle={false}
      run={open}
    />

    <style global jsx>
      {`
        .th-confetti {
          z-index: -1 !important;
          background: rgba(0, 0, 0, 0.5);
          opacity: 1;
          width: 100%;
          height: 100%;
          transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        }
      `}
    </style>
  </>
)

export default THConfetti
